'use strict';

var _PropTypes$shape;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMixin = require('react-mixin');

var _reactMixin2 = _interopRequireDefault(_reactMixin);

var InputGroup = require('./InputGroup');
var Input = require('./Input');
var Select = require('./Select');
var Mixin = require('../mixin');

var LINE1 = 'line1';
var LINE2 = 'line2';
var CITY = 'city';
var STATE = 'state';
var COUNTRY = 'country';
var POSTCODE = 'postcode';
var POSTALCODE = 'postal_code';
var DEFAULT_LAYOUT = [[COUNTRY], [LINE1], [LINE2], [CITY], [STATE], [POSTCODE]];
var DEFAULT_COUNTRY = 'US';

var countryPropValidator = function countryPropValidator(props, propName, componentName, location, propFullName) {
    function validate(props, propName, componentName, location) {
        var countries = props[propName];
        var countryKeys = Object.keys(countries);
        var countryKeyRegExp = new RegExp('^[A-Z]{2}$');
        for (var i = 0; i < countryKeys.length; i++) {
            if (!countryKeyRegExp.test(countryKeys[i])) {
                return new Error('Invalid ' + location + ' `' + propName + '` of key ' + ('`' + countryKeys[i] + '` supplied to `' + componentName + '`, expected a valid country code as the key.'));
            }
        }
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        if (props[propName] == null) {
            if (isRequired) {
                return new Error('Required ' + location + ' `' + propName + '` was not specified in ' + ('`' + componentName + '`.'));
            }
            return null;
        } else {
            return validate(props, propName, componentName, location, propFullName);
        }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
};

function getOptions(list) {
    var options = [];
    if (list) {
        Object.keys(list).forEach(function (key) {
            options.push({
                label: list[key],
                value: key
            });
        });
    }
    return options;
}

function getCountryOptions(list) {
    var options = [];
    Object.keys(list).forEach(function (key) {
        options.push({
            label: list[key]['name'],
            value: key
        });
    });
    return options;
}

//When country has states list but not state field in the layout. Eg. TR
//The state list should be city list.
function getCities(countryInfo, layout, state) {

    // layout
    if (layout) {
        var city = layout.properties && layout.properties.city;
        //For HK when state list and city list , filter based on state the selected cities
        if (city && city.groupList) {
            if (!state) {
                return [];
            }
            var cityGroup = city.groupList.find(function (group) {
                return group.id === state;
            }) || { group: [] };
            return cityGroup.group.map(function (city) {
                return { label: city.label, value: city.id };
            });
        } else if (city && Array.isArray(city.list)) {
            return city.list.map(function (obj) {
                return { label: obj.label, value: obj.id };
            });
        }
    } else {
        // Check if `state` field is available in the given layout.
        var hasState = function hasState(layout) {
            return layout && JSON.stringify(layout).indexOf('state') !== -1;
        };
        //Backward compatibility for the cities
        if (countryInfo && !hasState(countryInfo.addressLayout) && countryInfo.states) {
            return getOptions(countryInfo.states);
        }
    }
    return [];
}

//get States list
function getStates(countryInfo, layout) {
    // layout
    if (layout) {
        var state = layout.properties && layout.properties.state;
        if (state && Array.isArray(state.list)) {
            return state.list.map(function (obj) {
                return { label: obj.label, value: obj.id };
            });
        }
    } else {
        //Backward compatibility for the state
        if (countryInfo && countryInfo.states) {
            return getOptions(countryInfo.states);
        }
    }
    return [];
}

var Address = (function (_React$Component) {
    _inherits(Address, _React$Component);

    function Address(props) {
        _classCallCheck(this, Address);

        _get(Object.getPrototypeOf(Address.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Address';
    }

    _createClass(Address, [{
        key: 'getComponent',
        value: function getComponent(componentName) {
            var component = false,
                address = this.props.address || {},
                country = address.country || DEFAULT_COUNTRY,
                countryInfo = this.props.countries[country],
                layout = this.props.layout,
                disabled = this.props.disabled,

            //backward compatibility
            addressLabels = countryInfo && countryInfo.addressLabels,
                label = this.getLabel(componentName, addressLabels);

            switch (componentName) {
                case LINE1:
                    {
                        component = _react2['default'].createElement(Input, {
                            type: 'text',
                            key: 'line1',
                            id: this.props.id + '_line1',
                            label: label,
                            placeholder: label,
                            value: address[LINE1],
                            disabled: disabled,
                            errors: this.getErrors(LINE1),
                            onChange: this.onFieldChange.bind(this, LINE1),
                            onBlur: this.onFieldBlur.bind(this, LINE1)
                        });
                        break;
                    }
                case LINE2:
                    {
                        component = _react2['default'].createElement(Input, {
                            type: 'text',
                            key: 'line2',
                            id: 'line2',
                            label: label,
                            placeholder: label,
                            value: address[LINE2],
                            disabled: disabled,
                            errors: this.getErrors(LINE2),
                            onChange: this.onFieldChange.bind(this, LINE2),
                            onBlur: this.onFieldBlur.bind(this, LINE2)
                        });
                        break;
                    }
                case CITY:
                    {
                        var cityOptions = getCities(countryInfo, layout, address.state);
                        if (cityOptions.length > 0) {
                            component = _react2['default'].createElement(Select, {
                                options: cityOptions,
                                key: 'city',
                                id: this.props.id + '_city',
                                label: label,
                                placeholder: label,
                                value: address[CITY],
                                disabled: disabled,
                                errors: this.getErrors(CITY),
                                onChange: this.onFieldChange.bind(this, CITY),
                                onBlur: this.onFieldBlur.bind(this, CITY)
                            });
                        } else {
                            component = _react2['default'].createElement(Input, {
                                type: 'text',
                                key: 'city',
                                id: this.props.id + '_city',
                                label: label,
                                placeholder: label,
                                value: address[CITY],
                                disabled: disabled,
                                errors: this.getErrors(CITY),
                                onChange: this.onFieldChange.bind(this, CITY),
                                onBlur: this.onFieldBlur.bind(this, CITY)
                            });
                        }
                        break;
                    }
                case STATE:
                    {
                        var stateOptions = getStates(countryInfo, layout);
                        if (stateOptions && stateOptions.length === 0) {
                            component = _react2['default'].createElement(Input, {
                                type: 'text',
                                key: 'state',
                                id: this.props.id + '_state',
                                label: label,
                                placeholder: label,
                                value: address[STATE],
                                disabled: disabled,
                                errors: this.getErrors(STATE),
                                onChange: this.onFieldChange.bind(this, STATE),
                                onBlur: this.onFieldBlur.bind(this, STATE)
                            });
                        } else {
                            component = _react2['default'].createElement(Select, {
                                options: stateOptions,
                                key: 'state',
                                id: this.props.id + '_state',
                                label: label,
                                placeholder: label,
                                value: address[STATE],
                                disabled: disabled,
                                errors: this.getErrors(STATE),
                                onChange: this.onFieldChange.bind(this, STATE),
                                onBlur: this.onFieldBlur.bind(this, STATE)
                            });
                        }
                        break;
                    }
                case COUNTRY:
                    {
                        var countryOptions = getCountryOptions(this.props.countries);
                        component = _react2['default'].createElement(Select, {
                            options: countryOptions,
                            key: 'country',
                            id: this.props.id + '_country',
                            label: label,
                            placeholder: label,
                            value: address[COUNTRY],
                            disabled: disabled,
                            errors: this.getErrors(COUNTRY),
                            onChange: this.onFieldChange.bind(this, COUNTRY),
                            onBlur: this.onFieldBlur.bind(this, COUNTRY)
                        });
                        break;
                    }
                case POSTCODE:
                case POSTALCODE:
                    {
                        component = _react2['default'].createElement(Input, {
                            type: 'text',
                            key: 'postcode',
                            id: this.props.id + '_postcode',
                            label: label,
                            placeholder: label,
                            value: address[POSTCODE],
                            disabled: disabled,
                            errors: this.getErrors(POSTCODE),
                            onChange: this.onFieldChange.bind(this, POSTCODE),
                            onBlur: this.onFieldBlur.bind(this, POSTCODE)
                        });
                        break;
                    }
            }
            return component;
        }
    }, {
        key: 'buildAddressComponent',
        value: function buildAddressComponent(layout) {
            var self = this,
                addressComponent = [];

            layout.forEach(function (components) {
                if (components) {
                    (function () {
                        var componentList = [];
                        components.forEach(function (component) {
                            componentList.push(self.getComponent(component));
                        });

                        if (self.props.formatter && componentList.length > 1) {
                            var sectionComponent = _react2['default'].createElement(
                                InputGroup.Section,
                                { key: 'section' },
                                componentList
                            );
                            addressComponent.push(sectionComponent);
                        } else {
                            addressComponent = addressComponent.concat(componentList);
                        }
                    })();
                }
            });

            return addressComponent;
        }
    }, {
        key: 'onFieldChange',
        value: function onFieldChange(field, value) {
            var address = this.cloneObject(this.props.address);
            // Clear fields when country is changed.
            if (field === COUNTRY) {
                address = this.clearFields(address);
            }
            //Set value based on the field.
            address[field] = value;
            // Reset city field for SG to avoid validation error.
            if (address.country === 'SG') {
                address.city = '';
            }

            // Call host onChange function.
            this.props.onChange(address);
        }
    }, {
        key: 'onFieldBlur',
        value: function onFieldBlur(field, value) {
            var address = this.cloneObject(this.props.address);
            if (this.props.onBlur) {
                this.props.onBlur(address);
            }
        }
    }, {
        key: 'clearFields',
        value: function clearFields(address) {
            if (address) {
                Object.keys(address).forEach(function (field) {
                    if (address[field]) {
                        address[field] = '';
                    }
                });
            }
            return address;
        }
    }, {
        key: 'getLayout',
        value: function getLayout(country) {
            var _props = this.props;
            var layout = _props.layout;
            var countries = _props.countries;

            return layout && layout.layout || countries[country] && countries[country].addressLayout || DEFAULT_LAYOUT;
        }
    }, {
        key: 'getLabel',
        value: function getLabel(component, addressLabels) {
            var _props2 = this.props;
            var layout = _props2.layout;
            var dictionary = _props2.dictionary;

            var key = 'properties.' + component + '.label';
            var label = undefined;
            if (layout) {
                label = this.i18n(layout, key);
            } else if (addressLabels) {
                //backward compatibility
                label = addressLabels[component];
            }
            if (!label || label === key) {
                label = this.i18n(dictionary, component + '.label');
            }
            return label;
        }
    }, {
        key: 'render',
        value: function render() {
            var selectedCountry = this.props.address && this.props.address.country || DEFAULT_COUNTRY,
                contiguous = this.props.contiguous,
                layout = this.getLayout(selectedCountry);

            return _react2['default'].createElement(
                InputGroup,
                {
                    id: this.props.id,
                    contiguous: contiguous,
                    label: this.props.label,
                    error: this.hasErrors()
                },
                this.buildAddressComponent(layout)
            );
        }
    }]);

    return Address;
})(_react2['default'].Component);

Address.propTypes = {
    address: _propTypes2['default'].shape((_PropTypes$shape = {}, _defineProperty(_PropTypes$shape, LINE1, _propTypes2['default'].string), _defineProperty(_PropTypes$shape, LINE2, _propTypes2['default'].string), _defineProperty(_PropTypes$shape, CITY, _propTypes2['default'].string), _defineProperty(_PropTypes$shape, STATE, _propTypes2['default'].string), _defineProperty(_PropTypes$shape, POSTALCODE, _propTypes2['default'].string), _defineProperty(_PropTypes$shape, COUNTRY, _propTypes2['default'].string.isRequired), _PropTypes$shape)).isRequired,
    countries: _propTypes2['default'].object.isRequired, //TODO: add custom propType validation.
    dictionary: _propTypes2['default'].object.isRequired,
    onChange: _propTypes2['default'].func.isRequired,
    onBlur: _propTypes2['default'].func,
    label: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    errors: _propTypes2['default'].object,
    contiguous: _propTypes2['default'].bool,
    id: _propTypes2['default'].string,
    formatter: _propTypes2['default'].bool
};

Address.defaultProps = {
    contiguous: true,
    address: _defineProperty({}, COUNTRY, DEFAULT_COUNTRY),
    formatter: false
};

(0, _reactMixin2['default'])(Address.prototype, Mixin);

module.exports = Address;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Address.js
// module id = 952
// module chunks = 0 1